import apiClient from './apiClient';

const roomService = {
  // Adapter endpoint for list (camelCase response)
  getAll: (params) => apiClient.get('/v1/rooms', params),

  // DRF endpoints for CRUD (snake_case, trailing slash)
  getById: (id) => apiClient.get(`/rooms/rooms/${id}/`),
  create: (data) => apiClient.post('/rooms/rooms/', data),
  update: (id, data) => apiClient.patch(`/rooms/rooms/${id}/`, data),
  remove: (id) => apiClient.del(`/rooms/rooms/${id}/`),
  updateStatus: (id, data) => apiClient.put(`/v1/rooms/${id}/status`, data),
};

export default roomService;
